export default __webpack_public_path__ + "static/media/6.7521af0a.jpg";